<template lang='pug'>
    .address-list-container
        .address-item(v-for="item in recipients" :key="item.id")
            AddressPanel(:recipient="item" @clickArrow="clickArrow" @clickInfo="clickInfo")
</template>

<script>
import AddressPanel from '../components/AddressPanel'
import { getRecipients } from '@/service/member'
import { getStorage } from '@/utils/localstorage.js'
export default {
    components: {
        AddressPanel
    },
    data() {
        return {
            recipients: []
        }
    },
    methods: {
        clickArrow({ id }) {
            this.$router.push({ name: 'editAddress', params: { id } })
        },
        clickInfo() {
            this.$router.push({ name: 'order', params: { id: getStorage('te_m_order_productId') } })
        },
        async initData() {
            this.recipients = (await getRecipients()).data
        },
    },
    created() {
        this.initData()
    }
}
</script>

<style scoped lang='less'>
</style>